export const NULL_FILTER_TOKENS = ["__NULL__", "__EMPTY__"] as const;
export type NullFilterToken = typeof NULL_FILTER_TOKENS[number];

export const BLANK_FILTER_LABEL = "(空白)";

export const isNullFilterToken = (value: string): boolean =>
  NULL_FILTER_TOKENS.includes(value as NullFilterToken);

export const isBlankOrNullStatus = (
  item?: {
    name?: string | null;
    value?: string | number | null;
    id?: string | number | null;
    label?: string | null;
    text?: string | null;
    [key: string]: any;
  } | null,
): boolean => {
  if (!item) return true;
  const name = item.name ?? item.label ?? item.text;
  const value =
    item.value !== undefined && item.value !== null
      ? String(item.value)
      : (item as any).text !== undefined && (item as any).text !== null
      ? String((item as any).text)
      : undefined;
  const id =
    item.id !== undefined && item.id !== null ? String(item.id) : undefined;

  return (
    name === BLANK_FILTER_LABEL ||
    name === "__NULL__" ||
    name === "__EMPTY__" ||
    value === "__NULL__" ||
    value === "__EMPTY__" ||
    value === BLANK_FILTER_LABEL ||
    id === "__NULL__" ||
    id === "__EMPTY__"
  );
};
